import * as linkConst from '../../constants/link_constants'
import { BaseTableState } from './base'

export default (store) => {
  class TableState extends BaseTableState {
    attrs = [
      'id',
      'preview',
      'client_id',
      'contract_id',
      'month',
      'year'
    ]

    headertitles = [
      store.__('ID'),
      store.__('report'),
      store.__('client'),
      store.__('contract'),
      store.__('month'),
      store.__('year')
    ]

    title = store.__(linkConst.LINK_FINANCIAL_REPORTS_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_FINANCIAL_REPORTS]
    noSort=['preview']

    requiredOptions = [
      linkConst.LOAD_OPTIONS.contracts,
      linkConst.LOAD_OPTIONS.clients
    ]

    init () {
      return super.init()
    }
  }

  return { TableState }
}
